module.exports = __webpack_public_path__ + "static/media/purchase-image.90b4e783.png";